import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@asymmetrik/ngx-leaflet';
import { LeafletDirectiveWrapper } from '@asymmetrik/ngx-leaflet';
import * as L from 'leaflet';
import 'leaflet.markercluster';

class LeafletMarkerClusterDirective {
    constructor(leafletDirective) {
        // Hexbin data binding
        this.markerData = [];
        // Fired when the marker cluster is created
        this.markerClusterReady = new EventEmitter();
        this.leafletDirective = new LeafletDirectiveWrapper(leafletDirective);
    }
    ngOnInit() {
        this.leafletDirective.init();
        const map = this.leafletDirective.getMap();
        this.markerClusterGroup = L.markerClusterGroup(this.markerClusterOptions);
        // Add the marker cluster group to the map
        this.markerClusterGroup.addTo(map);
        // Set the data now that the markerClusterGroup exists
        this.setData(this.markerData);
        // Fire the ready event
        this.markerClusterReady.emit(this.markerClusterGroup);
    }
    ngOnChanges(changes) {
        // Set the new data
        if (changes['markerData']) {
            this.setData(this.markerData);
        }
    }
    setData(layers) {
        // Ignore until the markerClusterGroup exists
        if (null != this.markerClusterGroup) {
            this.markerClusterGroup.clearLayers();
            this.markerClusterGroup.addLayers(layers);
        }
    }
}
LeafletMarkerClusterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.4", ngImport: i0, type: LeafletMarkerClusterDirective, deps: [{ token: i1.LeafletDirective }], target: i0.ɵɵFactoryTarget.Directive });
LeafletMarkerClusterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.4", type: LeafletMarkerClusterDirective, selector: "[leafletMarkerCluster]", inputs: { markerData: ["leafletMarkerCluster", "markerData"], markerClusterOptions: ["leafletMarkerClusterOptions", "markerClusterOptions"] }, outputs: { markerClusterReady: "leafletMarkerClusterReady" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.4", ngImport: i0, type: LeafletMarkerClusterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[leafletMarkerCluster]',
                }]
        }], ctorParameters: function () { return [{ type: i1.LeafletDirective }]; }, propDecorators: { markerData: [{
                type: Input,
                args: ['leafletMarkerCluster']
            }], markerClusterOptions: [{
                type: Input,
                args: ['leafletMarkerClusterOptions']
            }], markerClusterReady: [{
                type: Output,
                args: ['leafletMarkerClusterReady']
            }] } });

class LeafletMarkerClusterModule {
}
LeafletMarkerClusterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.4", ngImport: i0, type: LeafletMarkerClusterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LeafletMarkerClusterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.4", ngImport: i0, type: LeafletMarkerClusterModule, declarations: [LeafletMarkerClusterDirective], exports: [LeafletMarkerClusterDirective] });
LeafletMarkerClusterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.4", ngImport: i0, type: LeafletMarkerClusterModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.4", ngImport: i0, type: LeafletMarkerClusterModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [LeafletMarkerClusterDirective],
                    declarations: [LeafletMarkerClusterDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LeafletMarkerClusterDirective, LeafletMarkerClusterModule };
